import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from '../Store/Store'

export interface ShopRequest {
  name?: string,
  banner?: string,
  status?: string,
}
export const shopApi = createApi({
  reducerPath: 'shopApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api',
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  tagTypes: ['shop-setting','clients','factors'],

  endpoints: (builder) => ({
    getShopSetting: builder.query({
      query: () => 'shop/getShopSetting',
      providesTags: ['shop-setting']
    }),
    editShopSetting: builder.mutation<boolean, ShopRequest>({
      query: (data) => ({
        url: 'shop/editSetting',
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['shop-setting']
    }),
    getClients: builder.query({
      query: () => 'client/all',
      providesTags: ['clients']
    }),
    getFactors: builder.query({
      query: () => 'factor/all',
      providesTags: ['factors']
    }),
    getFactor: builder.query<any,any>({
      query: (id) => `factor/one/${id}`,
      providesTags: ['factors']
    }),
  }),
})

export const { useGetShopSettingQuery , useEditShopSettingMutation , useGetClientsQuery , useGetFactorQuery , useGetFactorsQuery } = shopApi